import React from 'react';
import { getRewards } from '../api/users';
import { useLocation } from 'react-router-dom';
import PortalSessionContext from './PortalSessionContext/PortalSessionContext';
import dayjs from 'dayjs';
const BonusContext = React.createContext(
	{} as {
		draftstarsRewards: Rewards[];
		wageringRewards: Rewards[];
		refreshClientUserBonuses: (brand: 'Betting' | 'Fantasy') => void;
		updateActiveBrand: (brand: 'Betting' | 'Fantasy') => void;
		activeBrand: 'Betting' | 'Fantasy';
		tick: dayjs.Dayjs;
	}
);
export const BonusContextProvider = ({ children }: { children: React.ReactNode }) => {
	const [draftstarsRewards, setDraftstarsRewards] = React.useState<Rewards[]>([]);
	const [wageringRewards, setWageringRewards] = React.useState<Rewards[]>([]);
	const [tick, setTick] = React.useState(dayjs());

	React.useEffect(() => {
		const intervalId = setInterval(() => {
			setTick(dayjs());
		}, 1000);
		return () => {
			clearInterval(intervalId);
		};
	}, []);
	const location = useLocation();
	const activeApp = React.useMemo(() => {
		return location.pathname.startsWith('/betting') ? 'Betting' : 'Fantasy';
	}, [location.pathname]);
	const [activeBrand, setActiveBrand] = React.useState<'Betting' | 'Fantasy'>(activeApp);
	const { user } = React.useContext(PortalSessionContext);
	React.useEffect(() => {
		(async () => {
			if (!user?.id) return;
			const { data: bettingRewards } = await getRewards('1');
			const { data: fantasyRewards } = await getRewards('2');
			setWageringRewards(bettingRewards);
			setDraftstarsRewards(fantasyRewards);
		})();
	}, [user?.id, activeApp]);
	const updateActiveBrand = React.useCallback((brand: 'Betting' | 'Fantasy') => {
		setActiveBrand(brand);
	}, []);
	const refreshClientUserBonuses = React.useCallback(async (brand: 'Betting' | 'Fantasy') => {
		const { data } = await getRewards(brand === 'Betting' ? '1' : '2');
		if (brand === 'Betting') {
			setWageringRewards(data);
		} else {
			setDraftstarsRewards(data);
		}
	}, []);
	return (
		<BonusContext.Provider
			value={{
				tick,
				draftstarsRewards,
				wageringRewards,
				refreshClientUserBonuses,
				updateActiveBrand,
				activeBrand,
			}}
		>
			{children}
		</BonusContext.Provider>
	);
};
export const useBonusContext = () => {
	const context = React.useContext(BonusContext);
	if (context === undefined) {
		throw new Error('useBonusContext must be used within a BonusContextProvider');
	}
	return context;
};
